import type { ShopifyApiVersion } from "@intelligems/ig-types/functions/shopify/api-version";
import { fromProcess } from "@intelligems/ig-utils/env";

export const CoreKeys = {
  IG_ID_KEY: "ig-id",
  IG_FV_KEY: "ig-fv",
  IG_VARS_KEY: "ig-vars",
  IG_IGNORED_KEY: "ig-ignored",
  IG_TOKEN_KEY: "ig-auth-token",
  IG_PAGE_VIEW_COUNT_KEY: "ig-pv",
  ID_SIZE: 36,
  ID_PREFIX: "ig",
  ID_SPACER: "_",
  ID_COOKIE_DAYS_TO_LIVE: 365,
  INTELLIGEMS_TRACK_ENDPOINT: fromProcess("VITE_API_URL", undefined)
    ? `${fromProcess("VITE_API_URL", undefined)}/v3/track`
    : "https://api.intelligems.io/v3/track",
  KLAVIYO_IDS_COOKIE: "ig-klaviyo-ids" as const,
  GEO_LOCATION_COOKIE: "ig-location" as const,
} as const;

export const StateKeys = {
  PREVIEW_KEY: "ig-preview" as const,
  PREVIEW_VARIATION_ID: "ig-variation" as const,
  BUILD_KEY: "ig-build" as const,
  INTEGRATION_KEY: "ig-integration" as const,
  OPT_KEY: "ig-opt" as const,
  SS_KEY: "ig-ss" as const,
  TG_KEY: "igTg" as const,
  SKIP_REDIRECT_KEY: "ig-skip-redirect" as const,
  BUILDER_KEY: "ig-builder" as const,
  BUILDER_MODE_KEY: "ig-builder-mode" as const,
  WARNINGS_KEY: "ig-warnings" as const,
  PREVIEW_ALL_TRAFFIC_KEY: "ig-preview-traffic" as const,
  SESSION_CONFIG_KEY: "ig-config" as const,
  SESSION_INIT_CONFIG_KEY: "ig-init-config" as const,
  CAMPAIGN_QUERY_PARAM_KEY: "ig-campaign" as const,
  GEO_LOCATION_COOKIE: "ig-location" as const,
  KLAVIYO_IDS_COOKIE: "ig-klaviyo-ids" as const,
  BUILDER_CONTAINER: "ig-container" as const,
  EMBEDDED_PREVIEW_QUERY_PARAM: "ig-embedded-preview" as const,
  EMBEDDED_PREVIEW_SESSION_STORAGE_KEY: "ig-embedded-preview" as const,
  EMBEDDED_PREVIEW_CACHE: "ig-cache" as const,
  LIVE_PREVIEW_KEY: "ig-live-preview" as const,
} as const;

export const CodeInjectorKeys = {
  CUSTOM_CSS_ID_KEY: "ig-custom-css",
  CUSTOM_JS_ID_KEY: "ig-custom-js",
};

// Literal, not a re-export: a value import would pull the ig-types barrel into
// the shopper bundle. The type annotation makes drift a compile error.
export const SHOPIFY_API_VERSION: ShopifyApiVersion = "2026-07";

export const ShopifyConstants = {
  apiVersion: SHOPIFY_API_VERSION,
  storefrontApiPath: `/api/${SHOPIFY_API_VERSION}/graphql.json`,
} as const;

export const IgEvent = {
  VARIATION_ASSIGNMENTS: "ig:variationAssignments",
  VARIATION_ASSIGNMENTS_INVALIDATED: "ig:variationAssignmentsInvalidated",
  HIDDEN_CHANGE: "ig:hiddenChange",
  CART_UPDATED: "ig:CartUpdated",
  // A bare signal (no detail) fired after MemCart processes a cart mutation
  // (plugin- or theme-initiated). Consumers read /cart.js themselves and debounce
  // the burst into one fetch — e.g. `shopify-cart@1`'s onCartChange. Unlike
  // CART_UPDATED this covers theme-initiated changes (when the ATC interceptor is on).
  CART_CHANGE: "ig:cartChange",
  READY: "ig:ready",
  INITIAL_RUN_DONE: "ig:initialRunDone",
  GATE_OPENED: "ig:gateOpened",
};
